<!-- 工控-配件型号管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增配件型号
      </el-button>
      <div class="former">
        <el-input
          v-model.trim="former['Name|Brand|ModelNumber:like']"
          placeholder="名称/品牌/型号"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="Name" label="配件名称" />
      <el-table-column prop="Brand" label="品牌" />
      <el-table-column prop="ModelNumber" label="型号" />
      <el-table-column prop="Remark" label="说明" />
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        "Name|Brand|ModelNumber:like": "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
    };
  },
  mounted() {},
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("ipc/model/accessory", {
          params: {
            where: this.former,
            ...this.pager,
            order: ["name", "brand", "model_number"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
        Name: "",
        Brand: "",
        ModelNumber: "",
        Remark: "",
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此配件型号吗？", "提示")
        .then(() => this.$axios.delete(`ipc/model/accessory/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>
